import { HttpClient } from "@angular/common/http";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfigService } from "@fuse/services/config.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-verify-post",
  templateUrl: "./verify-post.component.html",
  styleUrls: ["./verify-post.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class VerifyPostComponent implements OnInit, AfterViewInit {
  aFormGroup: FormGroup;
  showCaptcha = false;
  enableDoneBtn = false;
  recaptchaResponse = "";
  showResult = false;
  party_post_data: any = {}
  loading = false;
  showError = false;
  errorMsg = ""
  parameters: any = {};

  constructor(
    private _fuseConfigService: FuseConfigService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute
  ) {
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngAfterViewInit(): void {
    this.showCaptcha = true;
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((val) => {
      this.parameters = JSON.parse(JSON.stringify(val));
    });

    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required],
    });
  }

  resolved(event) {
    this.recaptchaResponse = event;
    if (event != '') {
      this.enableDoneBtn = true;
    } else {
      this.enableDoneBtn = false
    }
  }

  handleReset() {
    this.recaptchaResponse = '';
    this.enableDoneBtn = false;
  }

  onSubmit() {
    this.loading = true;
    this.http.post(environment.PUBLIC_PARTY_POST, {
      letter_id: this.parameters.id,
      captcha: this.recaptchaResponse,
    }, {
      headers: { "Content-Type": "application/json" },
    }).subscribe((val: any) => {
      if (val.status == "success") {
        this.party_post_data = val.data
        this.showResult = true;
        this.showError = false;
      } else {
        this.errorMsg = "Invalid receipt no."
        this.showError = true;
      }
      this.loading = false;
    })
  }

  onBack() {
    this.party_post_data = {}
    this.showResult = false;
    this.loading = false;
  }


  errorHandler(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }
}
